var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Assinatura/Token", closeOutside: false },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          [
            _c(
              "el-row",
              [
                _c("span", { staticClass: "title" }, [_vm._v("Token")]),
                _c(
                  "el-col",
                  {
                    staticClass: "margin-top",
                    attrs: { lg: 24, md: 24, sm: 24 }
                  },
                  [
                    _vm.usuario && _vm.usuario.nome
                      ? _c(
                          "el-row",
                          { staticClass: "token" },
                          [
                            _c(
                              "el-col",
                              { attrs: { lg: 22, md: 22, sm: 22 } },
                              [_c("span", [_vm._v(_vm._s(_vm.usuario.nome))])]
                            )
                          ],
                          1
                        )
                      : _c(
                          "el-row",
                          { staticClass: "container" },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { lg: 24, md: 24, sm: 24 }
                              },
                              [
                                _c("span", { staticClass: "border-span" }, [
                                  _vm._v("Não há token cadastrado.")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }),
                _vm.usuario && _vm.usuario.nome
                  ? _c(
                      "div",
                      {
                        staticClass: "labels-action",
                        class:
                          !_vm.usuario.dataAtualizacaoToken &&
                          !_vm.usuario.dataValidadeToken
                            ? "margin-top"
                            : ""
                      },
                      [
                        _c("div", { staticClass: "flex-column" }, [
                          _vm.usuario && _vm.usuario.dataAtualizacaoToken
                            ? _c("span", { staticClass: "font-12" }, [
                                _vm._v(
                                  "Atualizado em " +
                                    _vm._s(_vm.usuario.dataAtualizacaoToken)
                                )
                              ])
                            : _vm._e(),
                          _vm.usuario && _vm.usuario.dataValidadeToken
                            ? _c("span", { staticClass: "font-12" }, [
                                _vm._v(
                                  "Válido até " +
                                    _vm._s(_vm.usuario.dataValidadeToken)
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("el-row", { staticClass: "margin-top-20" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v("Assinatura simbólica")
              ]),
              _c("div", { staticClass: "container-img" }, [
                _vm.usuario && _vm.usuario.id && _vm.hasImagemAssinatura
                  ? _c("div", { staticClass: "border-img" }, [
                      _c("img", {
                        staticClass: "image-assinatura",
                        attrs: {
                          src:
                            "usuarios/publico/fa861ef9-9acb-4e88-a889-f603b043dc73/" +
                            _vm.usuario.id
                        }
                      })
                    ])
                  : _c("span", { staticClass: "border-span" }, [
                      _vm._v("Não há assinatura cadastrada.")
                    ])
              ]),
              _vm.hasImagemAssinatura
                ? _c("div", { staticClass: "flex-start" }, [
                    _vm.usuario.dataAtualizacaoAssinatura
                      ? _c("span", { staticClass: "font-12" }, [
                          _vm._v(
                            "Atualizado em " +
                              _vm._s(_vm.usuario.dataAtualizacaoAssinatura)
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab5f42e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab5f42e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalAssinaturaToken.vue
// module id = null
// module chunks = 